var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FB6F80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1384 15.2574L26.2993 12.6958C25.5905 12.4347 24.4341 12.4347 23.7253 12.6958L16.8862 15.2574C15.5682 15.7548 14.4988 17.2967 14.4988 18.7018V28.7739C14.4988 29.7811 15.1578 31.1117 15.9661 31.7085L22.8052 36.8192C24.0113 37.7269 25.9885 37.7269 27.1946 36.8192L34.0337 31.7085C34.842 31.0992 35.501 29.7811 35.501 28.7739V18.7018C35.5135 17.2967 34.4441 15.7548 33.1384 15.2574ZM29.3334 22.2208L23.9865 27.5678C23.7999 27.7543 23.5637 27.8413 23.3274 27.8413C23.0912 27.8413 22.8549 27.7543 22.6684 27.5678L20.6788 25.5533C20.3182 25.1927 20.3182 24.5959 20.6788 24.2353C21.0394 23.8747 21.6363 23.8747 21.9969 24.2353L23.3399 25.5782L28.0278 20.8903C28.3884 20.5297 28.9852 20.5297 29.3458 20.8903C29.7064 21.2509 29.7064 21.8602 29.3334 22.2208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtection);
export default __webpack_public_path__ + "static/media/icon_protection.bdc237e6cd2d75c0cb48f0d6a8a7c59a.svg";
export { ForwardRef as ReactComponent };